import { useEffect, useState } from 'react'
import {
  faJava,
  faGitAlt,
  faAngular,
  faReact,
  faJsSquare,
  faPython,
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p id='p1'>
            Hey there, great to have you here! Thanks for stopping by. 
            I'm Rahul Brahmbhatt, a proud alumnus of the New Jersey Institute of Technology, 
            where I earned my master's degree in Computer Science. But that's not all –
            I come armed with over 3 years of hands-on experience as a seasoned software engineer.
          </p>
          <p id='p1'>
            When not coding, I'm passionate about exploring diverse cuisines and experimenting in the kitchen. 
            I'm also an avid cricket enthusiast, finding parallels between its strategy and teamwork with software development, 
            and I enjoy cheering for team India and analyzing game strategies
          </p>
          <p align="LEFT" id='p1'>
            With my academic foundation, hands-on experience, and unquenchable curiosity across diverse passions, 
            I'm not just seeking opportunities; I'm ready to seize them. If you're looking for a software engineer 
            who brings creativity, clarity, and leadership to the table, let's connect. In the ever-evolving tech landscape, 
            I'm here to embrace change and make an impact, one line of code at a time.
          </p>
        </div>

        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faJava} color="#DD0031" />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faAngular} color="#F06529" />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faReact} color="#28A4D9" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faPython} color="#5ED4F4" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About